import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class GoogleMapsLoaderService {
  private static scriptLoaded = false;
  private static scriptLoadingPromise: Promise<void> | null = null;

  constructor() {}

  load(): Promise<void> {
    // If already loaded, return immediately
    if (GoogleMapsLoaderService.scriptLoaded) {
      return Promise.resolve();
    }

    // If loading is in progress, return the existing promise
    if (GoogleMapsLoaderService.scriptLoadingPromise) {
      return GoogleMapsLoaderService.scriptLoadingPromise;
    }

    // Start loading the script
    GoogleMapsLoaderService.scriptLoadingPromise = new Promise<void>((resolve, reject) => {
      // Check if the script is already in the DOM
      const existingScript = document.querySelector('script[src*="maps.googleapis.com/maps/api"]');

      if (existingScript) {
        GoogleMapsLoaderService.scriptLoaded = true;
        resolve();
        return;
      }

      // Create the script element
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        GoogleMapsLoaderService.scriptLoaded = true;
        resolve();
      };

      script.onerror = (error) => {
        console.error("Failed to load Google Maps script:", error);
        GoogleMapsLoaderService.scriptLoadingPromise = null;
        reject(new Error("Failed to load Google Maps script"));
      };

      // Append the script to the document head
      document.head.appendChild(script);
    });

    return GoogleMapsLoaderService.scriptLoadingPromise;
  }
}

// Factory function for APP_INITIALIZER
export function initializeGoogleMaps(
  googleMapsLoader: GoogleMapsLoaderService
): () => Promise<void> {
  return () => googleMapsLoader.load();
}
